<template>
    <div class="wrapper-body flex-1 search p-0">
        <div class="px-1rem">
            <h2 class="title2 mb-5" style="margin-top: 10px">{{ $t("res_Title_SearchResults") }}</h2>
            <!--tabs-->
            <nav class="border-bottom position-relative d-flex justify-content-between" style="margin-bottom: 40px">
                <v-tabs show-arrows v-model="active_tab">
                    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                    <v-tab :class="{ 'v-tab--active': selected_index == index }" v-for="(item, index) in tabs" v-bind:key="index" @click="showTab(item.id)">
                        {{ item.name }} ({{ item.count }})
                    </v-tab>
                </v-tabs>
            </nav>
        </div>

        <div class="px-1rem flex-1 overflow-auto" style="margin-bottom: 24px" v-if="this.tab === 1">
            <div class="d-flex justify-content-between align-items-baseline" >
                <h3 class="section-title mt-0">{{ $t("res_MenuItems_Correspondences") }} <span class="weight-400">({{ all_correspondencesTotalCount }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(2)" class="primary-text">{{ $t("res_Label_SeeAll") }}</a>
            </div>
            <v-card class="px-4 py-2">
                <table class="list-table table-colors">
                    <tr class="border-top" v-for="item in all_correspondences" :key="item.id" style="height: 4.875rem">
                        <td width="30%" style="min-width:250px">
                            <div v-if="item.fullSubject.length > 80" v-tooltip="item.fullSubject">
                                <span v-html="item.subject.substring(0, 80)"></span> ...
                            </div>
                            <div v-else>
                                <span v-html="item.subject"></span>
                            </div>
                        </td>
                        <td class="text-end text-warning">
                            <v-icon>{{ utils.getOverDue(item.overdue, 2) }}</v-icon> {{ utils.getOverdueDays(item.overdue, item.overdueDays, 2) }}
                        </td>
                        <td> {{ formatDate(item.transferDueDate) }}</td>
                        <td v-text="item.toStructureName"></td>
                        <td v-text="getPurposeName(item.purposeId)"></td>
                        <td>
                            <v-chip dark :color="getStatusColor(item.statusId)">{{ getStatusName(item.statusId) }}</v-chip>
                        </td>
                        <td v-text="item.toUserName"></td>
                        <td>Recieved on {{ formatDate(item.transferCreatedDate) }}</td>
                    </tr>
                </table>
            </v-card>

            <div class="d-flex justify-content-between align-items-baseline">
                <h3 class="section-title">{{ $t("res_MenuItems_Notes") }} <span class="weight-400">({{ all_notesTotalCount }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(3)" class="primary-text">{{ $t('res_Label_SeeAll') }}</a>
            </div>
            <div class="grid-4-items gap-4">
                <v-card v-for="note in all_notes" :key="note.id" style="min-height: 7.5rem">
                    <div class="p-3 gap-3 align-items-start d-flex">
                        <div class="user">
                            <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(note.createdByUser) }}</v-avatar>
                        </div>
                        <div style="width: 100%">
                            <div class="d-flex justify-content-between py-2">
                                <span class="weight-500 size-16" style="line-height: 22px">{{ note.createdByUser }}</span>
                                <span class="size-12 dark-text" style="line-height: 18px">{{ formatDate(note.createdDate) }}</span>
                            </div>
                            <p style="line-height: 14px" v-html="highlightText(note.noteText)"></p>
                            <div v-if="note.documentSubject.length > 70" style="width: 100%; padding-top: 10px;line-height: 14px" v-tooltip="note.documentSubject">
                                {{ note.documentSubject.substring(0, 70) + '...' }}
                            </div>
                            <div style="line-height: 14px" v-else>
                                {{ note.documentSubject }}
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>

            <div class="d-flex justify-content-between align-items-baseline">
                <h3 class="section-title">{{ $t("res_Label_Attachments") }} <span class="weight-400">({{ all_attachmentsTotalCount }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(4)" class="primary-text">{{ $t('res_Label_SeeAll') }}</a>
            </div>
            <v-card class="px-4">
                <table class="list-table table-colors">
                    <tr class="border-top" v-for="item in all_attachments" :key="item.id" style="height: 4.875rem">
                        <td width="5%" class="text-center">
                            <v-icon large class="attachment_icon" v-if="item.Extension === 'pdf'">mdi-file-pdf-box</v-icon>
                            <v-icon large class="attachment_icon" v-if="item.Extension === 'doc' || item.Extension === 'docx'">mdi-file-word</v-icon>
                            <v-icon large class="attachment_icon" v-if="item.Extension !== 'doc' && item.Extension !== 'docx' && item.Extension !== 'pdf'">mdi-file</v-icon>
                        </td>
                        <td width="24%" style="min-width:250px">
                            <div v-if="item.FullName.length > 70" style="width: 100%; padding-top: 10px;" v-tooltip="item.FullName">
                                <span v-html="item.Name.substring(0, 70)"></span> ...
                            </div>
                            <div v-else>
                                <span v-html="item.Name"></span>
                            </div>
                        </td>
                        <td width="37%" style="min-width:220px">
                            <div v-if="item.DocumentSubject.length > 70" style="width: 100%; padding-top: 10px;" v-tooltip="item.DocumentSubject">
                                {{ item.DocumentSubject.substring(0, 70) + '...' }}
                            </div>
                            <div v-else>
                                {{ item.DocumentSubject }}
                            </div>
                        </td>
                        <td width="15%" class="text-start" v-if="item.ModifiedDate != null"> {{$t("res_Label_LastModified") }} {{ formatDate(item.ModifiedDate) }}</td>
                        <td width="15%" class="text-start" v-else> {{$t("res_Label_LastModified") }} {{ formatDate(item.CreatedDate) }}</td>
 
                        <td width="7%" v-text="item.CreatedByUser"></td>
                        <td width="7%">
                            {{ utils.formatBytes(item.FileSize, 2) }}
                        </td>
                        <td width="10%" class="text-center">
                            <v-btn width="40px"><v-icon class="custom-icon" @click="downloadAttachment(item.AttachmentId, item.FullName)">mdi-download</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </table>
            </v-card>

            <div class="d-flex justify-content-between align-items-baseline">
                <h3 class="section-title">{{ $t("res_MenuItems_Users") }} <span class="weight-400">({{ all_usersTotalCount }}{{ all_usersTotalCountPlus }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(5)" class="primary-text">{{ $t('res_Label_SeeAll') }} </a>
            </div>
            <div class="grid-4-items">
                <v-card v-for="item in all_users" :key="item.id" style="min-height: 118px">
                    <div class="p-3 gap-3 align-items-start h-100 d-flex" style="width: 100%">
                        <div class="user">
                            <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(item.name) }}</v-avatar>
                        </div>
                        <div class="position-relative pb-3 h-100" style="width: 100%">
                            <h4 class="mb-2 d-block" v-html="highlightText(item.name)"></h4>
                            <p>{{ item.profession }}<span v-if="item.profession != '' && item.parentName != ''">, </span>{{ item.parentName}}</p>
                            <span class="text-bottom">{{ item.companyName}}</span>
                        </div>
                    </div>
                </v-card>
            </div>

            <div class="d-flex justify-content-between align-items-baseline">
                <h3 class="section-title">{{ $t("res_MenuItems_Templates") }} <span class="weight-400">({{ all_templatesTotalCount }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(6)" class="primary-text">{{ $t('res_Label_SeeAll') }}</a>
            </div>
            <div class="grid-4-items">
                <v-card class="p-3" v-for="item in all_templates" :key="item.id" @dblclick="templateClicked(item)"> 
                    <v-chip dark class="mb-3" color="purple">{{ item.language }}</v-chip>
                    <v-chip dark class="mb-3 mx-2" color="purple">{{ getCategoryName(item.categoryId) }}</v-chip>
                    <h4>
                        <span v-html="highlightText(item.name)"></span>
                    </h4>
                    <p>{{ item.descriptionEn }}</p>
                </v-card>
            </div>

            <div class="d-flex justify-content-between align-items-baseline">
                <h3 class="section-title">{{ $t("res_MenuItems_Reports") }} <span class="weight-400">({{ all_reportsTotalCount }})</span></h3>
                <v-spacer></v-spacer>
                <a @click="goToTabPage(7)" class="primary-text">{{ $t('res_Label_SeeAll') }}</a>
            </div>
            <div class="grid-4-items">
                 <!-- <v-card  class="d-flex align-items-end"  style="padding: 10px; height: 8.5rem">
                    <h3 class="dark-title size-16">{{ item.titleEn }}</h3>
                    <p>{{ item.descriptionEn }}</p>
                </v-card> -->
                <v-card v-for="item in all_reports" :key="item.id" @click="openReport(item.id)" style="min-height: 118px"> 
                    <div class="p-3 gap-3 align-items-start h-100 d-flex" style="width: 100%">
                        <div class="position-relative pb-1 h-100" style="width: 100%" >   
                            <h4 v-html="highlightText(item.titleEn)">
                            </h4>
                            <p>{{ item.descriptionEn}}</p>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>

        <v-row class="px-1rem flex-1 overflow-auto mx-0" style="margin-bottom: 24px" v-if="this.tab !== 1 && this.tab !== 5 && this.tab !== 6 && this.tab !== 7">
            <div class="col-md-2 p-0 pr-5 sm-left-fixed flex-1 overflow-auto d-flex h-100" v-if="filter_Visible">
                <v-card class="filter-card shadow-none d-flex flex-column w-100 h-100" >
                    <div class="overflow-auto px-3 d-flex flex-column flex-1" >
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <h3 class="size-14 dark-text mb-0">{{ $t('res_MenuItems_Filter') }}</h3>
                            <v-btn class="btn-text text-primary" style="height: auto; min-height: unset" @click="filter_Visible=false">
                                <v-icon class="rtl-flip">mdi-chevron-left</v-icon>Hide
                            </v-btn>
                        </div>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_Transfer") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <!-- From Structure Filter -->
                                    <div class="mt-0">
                                        <label>{{ $t("res_Label_SentFrom") }}</label>
                                        <multiselect v-model="selectedFromStructure" label="name" track-by="id"
                                            open-direction="bottom" placeholder="Select From Structure"
                                            :options="structures" :searchable="true" :loading="loading"
                                            :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                            :options-limit="300" :max-height="600" :show-no-results="false"
                                            :hide-selected="false" :multiple="false" @search-change="getStructures"
                                            @close="structures = []">
                                            <template slot="option" slot-scope="props">
                                                <div style="height: 50px; width: 100%; display: flex">
                                                    <div class="" style="">
                                                        <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                                    </div>
                                                    <div class="ad__box" v-if="props.option.isUser">
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                    </div>
                                                    <div class="ad__box" v-else>
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="noOptions" slot-scope="props">
                                                {{$t("res_Msgs_EmptySearch")}}
                                            </template>
                                        </multiselect>
                                    </div>

                                    <!-- To Structure Filter -->
                                    <div class="mt-3">
                                        <label>{{ $t("res_Label_SentTo")}}</label>
                                        <multiselect v-model="selectedToStructure" label="name" track-by="id"
                                            open-direction="bottom" placeholder="Select To Structure"
                                            :options="structures" :searchable="true" :loading="loading"
                                            :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                            :options-limit="300" :max-height="600" :show-no-results="false"
                                            :hide-selected="false" :multiple="false" @search-change="getStructures"
                                            @close="structures = []">
                                            <template slot="option" slot-scope="props">
                                                <div style="height: 50px; width: 100%; display: flex">
                                                    <div class="" style="">
                                                        <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                                    </div>
                                                    <div class="ad__box" v-if="props.option.isUser">
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                    </div>
                                                    <div class="ad__box" v-else>
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="noOptions" slot-scope="props">
                                                {{$t("res_Msgs_EmptySearch")}}
                                            </template>
                                        </multiselect>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_Category") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in categoryFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="selectedCategory" :value="item.id" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_Priority") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in priorityFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="selectedPriority" :value="item.id" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_Privacy") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in privacyFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="selectedPrivacy" :value="item.id" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_DocumentStatus") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in statueFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="selectedStatus" :value="item.id" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_DocumentDate") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in dateFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="selectedDocumentDate" :value="item.text" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 3">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_CreatedDate") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in notesDateFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="note_createDateFilterValue" :value="item.text" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels accordion v-if="this.tab === 3">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_CreatedUser") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <multiselect class="light-bg" v-model="note_createdByUserFilterValue" label="name"
                                        track-by="id" open-direction="bottom" :options="notes_usersList"
                                        :searchable="true" :loading="loading" :internal-search="false"
                                        :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                        :max-height="600" :show-no-results="false" :hide-selected="true"
                                        :multiple="false" @search-change="asyncFindUser" @close="notes_usersList = []">
                                        <template slot="option" slot-scope="props">
                                            <div style="height: 50px; width: 100%; display: flex">
                                                <div class="" style="">
                                                    <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                                </div>
                                                <div class="ad__box" v-if="props.option.isUser">
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                </div>
                                                <div class="ad__box" v-else>
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="noOptions" slot-scope="props">
                                            {{$t("res_Msgs_EmptySearch")}}
                                        </template>
                                    </multiselect>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <v-expansion-panels accordion v-if="this.tab === 4">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{  $t("res_Label_FileExtension") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in fileExtensionsFilter" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="attachments.fileExtension" :value="item.text" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <v-expansion-panels accordion v-if="this.tab === 4">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{ $t("res_Label_CreatedDate") }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(item, i) in dateFilters" :key="i">
                                        <div class="d-flex align-items-center mb-1">
                                            <v-checkbox v-model="attachments.createdDate" :value="item.text" style="margin-top: 0px"></v-checkbox>
                                            <label>{{ (item.text + ' (' + item.count + ')') }}</label>
                                        </div>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>

                    <v-card-actions class="gap-2 sticky-actions justify-content-between">
                        <v-btn class="text-primary btn-text" @click="clearAllFilters();">{{ $t("res_Label_ClearAll") }}</v-btn>
                        <v-btn class="primary" style="min-width: 90px !important" @click="search()">{{ $t("res_ButtonText_Apply") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            
            <div class="col-md-100 col-4 pt-0 col-xl-3 pb-0 pl-0 flex-1 overflow-auto d-flex flex-column h-100">
                <v-btn v-if="!filter_Visible" class="btn-text text-primary align-self-start mb-2" style="height: unset; min-height: unset" @click="filter_Visible=true">
                    <v-icon class="rtl-flip">mdi-chevron-right</v-icon>{{ $t('res_MenuItems_Filter') }}
                </v-btn>
                <!--<v-card class="overflow-y-auto"
                    v-bind:style="filter_Visible == false ? { 'min-height': 'calc(100vh - 307px)', 'max-height': 'calc(100vh - 286px)' } : { 'height': 'calc(100vh - 272px)'}"
                    style="padding: 24px 4px">-->

                <v-card class="overflow-y-auto flex-1 shadow-none p-1 h-100">
                    <div class="d-flex flex-1 flex-column overflow-auto h-100">
                    <h2 class="size-14 weight-500 dark-text m-0 py-3 px-3" >{{ $t("res_GridHeaders_MyInbox") }}</h2>

                    <div v-if="this.tab === 2">
                        <div class="px-4 py-2 light-blue-hover" v-for="(item, i) in correspondence_items" :key="i" @click="handleResultClicked(item), openPreviewPane=true, showViewerDialog=true">
                            <h3 class="d-inline-block w-75 mb-0">
                                <div v-if="item.subject.length > 80" v-tooltip="item.subject">
                                    <h4 class="weight-400 mb-0" v-html="highlightText(item.subject.substring(0, 80) + '...')"></h4>
                                </div>
                                <div v-else>
                                    <h4 class="weight-400 mb-0" v-html="highlightText(item.subject)"></h4>
                                </div>
                            </h3>
                            <label class="float-end text-warning mx-2">
                                <v-icon>{{ utils.getOverDue(item.overdue, 2) }}</v-icon> {{ utils.getOverdueDays(item.overdue, item.overdueDays, 2) }}
                            </label>

                            <p class="d-inline-block w-75 mb-1">{{item.toStructureName}}</p>
                            <span class="float-end text-small" style="line-height: 14px">{{ formatDate(item.transferCreatedDate) }}</span>
<br>
                            <v-chip dark  class="size-12" style="line-height: 14px" :class="getColor(item.status)">{{ item.status }}</v-chip>
                            <span class="mx-2 text-small">{{ item.purpose }}</span>
                            <span class="float-end" v-if="item.attachmentId !== null">
                                <v-icon>mdi-attachment</v-icon>
                            </span>
                        </div>
                        <div v-if="allowCorrespondenceItemsLoadMore">
                            <InfiniteLoading @infinite="loadMoreCorrespondences">
                                <div slot="spinner"></div>
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </InfiniteLoading>
                        </div>
                    </div>  

                    <div v-if="this.tab === 3">
                        <div class="px-4 py-2 light-blue-hover" v-for="(item, i) in note_items" :key="i"
                            @click="handleResultClicked(item),  openPreviewPane=true, showViewerDialog=true">
                            <h3 class="d-inline-block w-75 mb-0">
                                <div v-if="item.noteText.length > 120" v-tooltip="item.noteText">
                                    <h4 class="weight-400 mb-0" v-html="highlightText(item.noteText.substring(0, 120) + '...')"></h4>
                                </div>
                                <div v-else>
                                    <h4 class="weight-400 mb-0" v-html="highlightText(item.noteText)"></h4>
                                </div>
                            </h3>
                            <!-- <label class="float-end text-warning">
                                <v-icon>mdi-overdue</v-icon> overdue
                            </label> -->
                            <!-- <p class="d-inline-block w-75 mb-1">{{item.NoteText}}</p> -->
                            <span class="float-end text-small" style="line-height: 14px">{{ formatDate(item.createdDate.replace('T00:00:00','')) }}</span>
                            <br>
                            <!-- <v-chip dark :class="getColor(item.status)">{{ item.status }}</v-chip> -->
                            <span class="mx-0 text-small">{{item.createdByUser }}</span>
                            <span class="float-end" v-if="item.attachmentId !== null">
                                <v-icon>mdi-attachment</v-icon>
                            </span>
                        </div>
                        <div v-if="allowNoteItemsLoadMore">
                            <InfiniteLoading @infinite="loadMoreNotes">
                                <div slot="spinner"></div>
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </InfiniteLoading>
                        </div>
                    </div>

                    <div v-if="this.tab === 4">
                        <div class="px-4 py-2 light-blue-hover" v-for="(item, i) in attachments.attachmentData" :key="i" :class="{show : attachments.attachmentTab}"
                            @click="handleResultClicked(item),  openPreviewPane=true, showViewerDialog=true">
                            <h3 class="d-inline-block w-75 mb-0">
                                 <h4 class="weight-400 mb-0" v-html="highlightText(item.Name)"></h4>
                            </h3>
                            <!-- <label class="float-end text-warning">
                                <v-icon>mdi-overdue</v-icon> overdue
                            </label> -->
                            <!-- <p class="d-inline-block w-75 mb-1">{{item.NoteText}}</p> -->
                            <span class="float-end text-small" style="line-height: 14px">{{ formatDate(item.CreatedDate) }}</span>
                            <br>
                            <!-- <v-chip dark :class="getColor(item.status)">{{ item.status }}</v-chip> -->
                            <span class="text-small">{{item.FileExtension }}</span>
                            <span class="float-end"><v-icon>mdi-attachment</v-icon></span>
                        </div>
                        <div v-if="allowAttachmentItemsLoadMore">
                            <InfiniteLoading @infinite="loadMoreAttachments">
                                <div slot="spinner"></div>
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </InfiniteLoading>
                        </div>
                    </div>
                    </div>
                </v-card>
            </div>
           
            <div class="col pt-0 sm-full-view viewer-col pb-0 pr-0 flex-1 overflow-auto" :class="{show : showViewerDialog}" v-if="openPreviewPane">
                <v-btn @click="closePreview()" class="close-btn sm-screen back-btn light-btn mb-3" icon dark>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                
                <div class="position-relative h-100" style="overflow-x: visible; background: #fff; border-radius: 8px">
                    <!--action buttons-->
                    <div v-if="!no_item_selected" class="d-flex justify-content-between align-items-center bottom-action-bar m-0 gap-2 align-left">
                        <TransferNotesIcon ref="transferNotesIcon"></TransferNotesIcon>
                        
                        <div class="d-flex gap-2">                            
                            <v-btn color="light-success" @click="openFullView"><v-icon class="custom-icon">mdi-check-ring</v-icon>Full View</v-btn>
                        </div>
                    </div>
                    <div class="d-flex flex-column h-100">
						<div class="p-0 scrollable-container flex-1">
                            <div v-if="no_item_selected" class="empty-viewer" style="border-radius: 12px; background: #E7EBEF;">
                                <img src="/assets/images/icons/template.svg" />
                                <img src="/assets/images/icons/no_preview.svg" />
                                <h2>{{ $t("res_Msgs_NoSelected") }}</h2>
                                <p>{{ $t("res_Msgs_SelectItem") }}</p>
                            </div>
                            <div v-if="empty_viewer & !no_item_selected" class="empty-viewer" style="border-radius: 12px; background: #E7EBEF;">
                                <img src="/assets/images/icons/template.svg" />
                                <img src="/assets/images/icons/no_preview.svg" />
                                <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreview") }}</p>
                            </div>
                            <div v-if="!empty_viewer" id="viewer_template" class="h-100" style="border-radius: 10px;">
                                <!-- <vue-pdf-embed :source="templateSource" /> -->
                                <iframe id="viewerFrame" :src="viewerFrame" class="h-100 w-100"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-row>

        <div class="px-1rem flex-1 overflow-auto" style="margin-bottom: 24px" v-if="this.tab === 5">
            <div class="grid-4-items">
                <v-card v-for="item in user_items" :key="item.id"> 
                    <div class="p-3 gap-3 align-items-start h-100 d-flex" style="width: 100%">
                        <div class="user">
                            <v-avatar color="#eff2f5" size="40">{{ CapitalizeFirstLetter(item.name) }}</v-avatar>
                        </div>
                        <div class="position-relative pb-3 h-100" style="width: 100%">
                            <h4 class="mb-2 d-block" v-html="highlightText(item.name)"></h4>
                            <p>{{ item.profession }}<span v-if="item.profession != '' && item.parentName != ''">, </span>{{ item.parentName}}</p>
                            <span class="text-bottom">{{ item.companyName}}</span>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>

        <div class="px-1rem flex-1 overflow-auto" style="margin-bottom: 24px" v-if="this.tab === 6">
            <div class="grid-4-items">
                <v-card class="p-3" v-for="item in template_items" :key="item.id" @dblclick="templateClicked(item)"> 
                    <v-chip dark class="mb-3" color="purple">{{ item.language }}</v-chip>
                    <v-chip dark class="mb-3 mx-2" color="purple">{{ item.category }}</v-chip>
                    <h4 v-html="highlightText(item.name)"></h4>
                    <p v-html="highlightText(item.descriptionEn)"></p>
                </v-card>
            </div>
        </div>

        <div class="px-1rem flex-1 overflow-auto" style="margin-bottom: 24px" v-if="this.tab === 7">
            <div class="grid-4-items gap-3">
                <v-card class="d-flex align-items-end" v-for="item in report_items" :value="item.id" :key="item.id" @click="openReport(item.id)" style="min-height: 118px">
                    <div class="p-3 gap-3 align-items-start h-100 d-flex" style="width: 100%">
                        <div class="position-relative pb-1 h-100" style="width: 100%" >   
                            <h4 class="d-block mb-2" v-html="highlightText(item.titleEn)">
                            </h4>
                            <p>{{ item.descriptionEn}}</p>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>

        <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen @keydown.esc="closeCorrespondenceDialog">
            <CreateDocumentView :documentId="documentId" :transferId="transferId" :viewMode="viewMode" :delegationId="delegationId" :closeDialogEvent="closeCorrespondenceDialog"/>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import constants from "@/assets/js/constants"
    import Multiselect from 'vue-multiselect'
	import * as utils from '@/assets/js/common.js'
	import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import InfiniteLoading from 'vue-infinite-loading'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'

    export default 
    {
        name: "Search",
        components: { Multiselect, CreateDocumentView, InfiniteLoading, TransferNotesIcon },
        data()
        {
            return {
                from: 0,
                pageSize: 20,
                active_tab: 0,
				selected_index: 0,
                tab: 1,
				tabs: [
					{ id: 1, name: 'All', count: 0 },
					{ id: 2, name: 'Correspondences', count: 0 },
					{ id: 3, name: 'Notes', count: 0 },
					{ id: 4, name: 'Attachments', count: 0 },
					{ id: 5, name: 'Users', count: 0 },
					{ id: 6, name: 'Templates', count: 0 },
					{ id: 7, name: 'Reports', count: 0 }
				],

				all_correspondences: [],
				all_notes: [],
				all_attachments: [],
				all_users: [],
				all_templates: [],
				all_reports: [],
                all_count: 0,
				all_correspondencesTotalCount: 0,
				all_notesTotalCount: 0,
				all_attachmentsTotalCount: 0,
				all_usersTotalCount: 0,
				all_usersTotalCountPlus: '+',
				all_templatesTotalCount: 0,
				all_reportsTotalCount: 0,

                note_createDateFilterValue: '',
                note_createDateFilter: false,
                note_createdByUserFilterValue: {},
                notes_usersList: [],

                correspondence_items: [],
                allowCorrespondenceItemsLoadMore: false,
                note_items: [],
                allowNoteItemsLoadMore: false,
                allowAttachmentItemsLoadMore: false,

                showViewerDialog: false,
                searchQuery: '',
                loading: false,
                filter_Visible: false,
                offset: true,
                selectedCategory: {},
                resetSelectedCategory: 0,
                selectedPriority: {},
                selectedPrivacy: {},
                selectedStatus: {},
                selectedDocumentDate: {},
                selectedToStructure: {},
                selectedFromStructure: {},
                divider: true,
                inset: true,
                priorities: [],
                privacies: [],
                statuses: [],
                categories: [],
                fileExtensions: [],
                dateFilters: [
                    { id: "1", text: "Last 30 Days", count: 0 },
                    { id: "2", text: "Last 60 Days", count: 0 },
                    { id: "3", text: "Last 180 Days", count: 0 },
                    { id: "4", text: "Older", count: 0 },
                ],
                notesDateFilters: [
                    { id: "1", text: "Last 30 Days", count: 0 },
                    { id: "2", text: "Last 60 Days", count: 0 },
                    { id: "3", text: "Last 180 Days", count: 0 },
                    { id: "4", text: "Older", count: 0 },
                ],
                structures:[],
                categoryFilters: [],
                priorityFilters: [],
                privacyFilters: [],
                statueFilters: [],
                ToStructureFilter: [],
                FromStructureFilter: [],
                fileExtensionsFilter: [],
                openPreviewPane: true,
                viewerFrame : '',
                empty_viewer: true,
                no_item_selected: true,
                isLanguageEn: true,

                attachments: {
                    attachmentTab: false,
                    attachmentData: [],
                    extensionFilter: {},
                    createdDate: {},
                    fileExtensions: [],
                    fileExtension: '',
                    name: '',
                },
                selected_item: {},
                correspondenceDialog: false,
                documentId: 0,
                transferId: 0,
                delegationId: 0,
                viewMode: 'readonly',
                user_items: [],
                template_items: [],
                report_items: [],

                template_click: 0,
                utils: utils,
                options: window.dateOptions,
            };
        },
		watch: 
		{
			$route() 
			{
                this.clearAllFilters()
                this.searchQuery = utils.getParameterByName('q')
                var t = utils.getParameterByName('t')
                if (t == null || t == undefined || t == '' || t == '1')
                {
                    this.tab = 1
                    this.active_tab = 0
                    this.selected_index = 0
                    this.GetSearchIndexResults()
                }
                else if (t == '2')  this.showTab(2)
                else if (t == '3')  this.showTab(3)
                else if (t == '4')  this.showTab(4)
                else if (t == '5')  this.showTab(5)
                else if (t == '6')  this.showTab(6)
                else if (t == '7')  this.showTab(7)
			}
		},
        mounted() 
        {
            this.tabs =  [
					{ id: 1, name: window.translate("res_CardHeaders_All"), count: 0 },
					{ id: 2, name: window.translate("res_MenuItems_Correspondences"), count: 0 },
					{ id: 3, name: window.translate("res_MenuItems_Notes"), count: 0 },
					{ id: 4, name: window.translate("res_Label_Attachments"), count: 0 },
					{ id: 5, name: window.translate("res_MenuItems_Users"), count: 0 },
					{ id: 6, name: window.translate("res_MenuItems_Templates"), count: 0 },
					{ id: 7, name: window.translate("res_MenuItems_Reports"), count: 0 }
				],

            this.searchQuery = utils.getParameterByName('q')
            var t = utils.getParameterByName('t')
            if (t == null || t == undefined || t == '' || t == '1')
            {
                this.tab = 1
                this.active_tab = 0
                this.selected_index = 0
                this.GetSearchIndexResults()
            }
            else if (t == '2')  this.showTab(2)
            else if (t == '3')  this.showTab(3)
            else if (t == '4')  this.showTab(4)
            else if (t == '5')  this.showTab(5)
            else if (t == '6')  this.showTab(6)
            else if (t == '7')  this.showTab(7)
        },
        methods: 
        {
            GetSearchIndexResults()
            {
                var query = utils.getParameterByName('q')
                if(query.trim().length < 3){
                    window.showAlert("Search text should not be less than 3 chars.","warning");
                    return;
                }
                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/GetSearchIndexResults', { query: query, isMiniVersion: false })
                    .then(response => 
                    {
                        this.all_correspondences = []
                        this.all_attachments = []
                        this.all_notes = []
                        this.all_templates = []
                        this.all_users = []
                        this.all_notes = []
                        this.all_correspondencesTotalCount = 0
                        this.all_notesTotalCount = 0
                        this.all_templatesTotalCount = 0
                        this.all_reportsTotalCount = 0
                        this.all_usersTotalCount = 0
                        this.all_attachmentsTotalCount = 0

                        if (response.data.correspondences !== '[]')
                        {
                            this.all_correspondences = JSON.parse(response.data.correspondences)
                            this.all_correspondences.forEach(element => 
                            {
                                element.fullSubject = element.subject
                                element.subject = this.highlightText(element.subject)
                            });
                        }

                        if (response.data.notes !== '[]')
                        {
                            this.all_notes = JSON.parse(response.data.notes)
                        }
                        
                        if (response.data.attachments !== '[]')
                        {
                            this.all_attachments = JSON.parse(response.data.attachments)
                            this.all_attachments.forEach(element => 
                            {
                                element.FullName = element.Name
                                element.Name = this.highlightText(element.Name)
                            });
                        }
                            
                        this.all_users = response.data.users
                        this.all_templates = response.data.templates
                        this.all_reports = response.data.reports

                        this.all_correspondencesTotalCount = response.data.correspondencesTotalCount
                        this.all_notesTotalCount = response.data.notesTotalCount
                        this.all_attachmentsTotalCount = response.data.attachmentsTotalCount
                        this.all_templatesTotalCount = response.data.templatesTotalCount
                        this.all_reportsTotalCount = response.data.reportsTotalCount

                        if (response.data.usersTotalCount > 100)
                        {
                            this.all_usersTotalCount = 100
                            this.all_usersTotalCountPlus = '+'
                        }    
                        else
                        {
                            this.all_usersTotalCount = response.data.usersTotalCount
                            this.all_usersTotalCountPlus = ''
                        }
                        
                        this.all_count = 
                                this.all_correspondencesTotalCount + this.all_notesTotalCount + 
                                this.all_templatesTotalCount + this.all_usersTotalCount +
                                this.all_reportsTotalCount + this.all_attachmentsTotalCount
                        ;

                        

                        this.tabs[0].count = this.all_count
                        this.tabs[1].count = this.all_correspondencesTotalCount
                        this.tabs[2].count = this.all_notesTotalCount
                        this.tabs[3].count = this.all_attachmentsTotalCount
                        this.tabs[4].count = this.all_usersTotalCount
                        this.tabs[5].count = this.all_templatesTotalCount
                        this.tabs[6].count = this.all_reportsTotalCount
                         
                    })
                    .catch(err => this.handleError(err))
                    .finally(() => window.hideLoading())
            },
            search(onSearchCompletedHandler)
            {
                this.searchQuery = utils.getParameterByName('q')

                if (this.tab === 2)
                {
                    this.allowCorrespondenceItemsLoadMore = false
                    this.from = 0
                    this.getCorrespondenceItems(onSearchCompletedHandler)
                }
                else if(this.tab === 3)
                {
                    this.allowNoteItemsLoadMore = false
                    this.from = 0
                    this.getNotesDataByFilter(onSearchCompletedHandler);
                }
                else if(this.tab === 4)
                {
                    this.allowAttachmentItemsLoadMore = false
                    this.from = 0
                    this.getAttachmentsDataByFilter(onSearchCompletedHandler)
                }
            },
            clearAllFilters()
            {
                this.selectedCategory = {}
                this.selectedPriority = {}
                this.selectedPrivacy = {}
                this.selectedStatus = {}
                this.selectedDocumentDate = {}
                this.selectedToStructure = {}
                this.selectedFromStructure = {}
                this.note_createDateFilterValue = ''
                this.note_createdByUserFilterValue = {}
                this.attachments.fileExtension = {}
                this.attachments.createdDate = {}
                this.search(()=>
                {
                    this.selectedCategory = {}
                    this.selectedPriority = {}
                    this.selectedPrivacy = {}
                    this.selectedStatus = {}
                    this.selectedDocumentDate = {}
                    this.selectedToStructure = {}
                    this.selectedFromStructure = {}
                    this.note_createDateFilterValue = ''
                    this.note_createdByUserFilterValue = {}
                    this.attachments.fileExtension = {}
                    this.attachments.createdDate = {}
                })
            },
            downloadAttachment(attachmentId, fileName)
            {
                utils.DownloadFile(constants.baseApiUrl + 'Attachment/Download?attachmentId=' + attachmentId, fileName)
            },
            viewLetter()
            {
                var methodUrl = 'Search/updateDocumentByFilterValue';

                axios.post(constants.baseApiUrl + methodUrl, { headers: constants.headers })
                    .then(res => 
                        {
                            if(res != null)
                            {
                                alert(res);
                            }
                        }
                    )
                    .catch(err => console.warn(err))
            },
            showTab(pageNumber)
            {
                this.tab = pageNumber
                this.active_tab = pageNumber - 1
                this.selected_index = pageNumber - 1

                this.no_item_selected = true
                this.correspondence_items = []
                this.note_items = []

                if (this.tab == 2)
                {
                    this.getLookups()
                    this.empty_viewer = true
                    this.attachments.attachmentTab = false
                    this.from = 0
                    this.allowCorrespondenceItemsLoadMore = false
                    this.getCorrespondenceItems()
                }
                else if(this.tab == 3)
                {
                    this.empty_viewer = true
                    this.attachments.attachmentTab = false
                    this.from = 0
                    this.allowNoteItemsLoadMore = false
                    this.getNotesDataByFilter();
                }
                else if(this.tab == 4)
                {
                    this.getLookups()
                    this.empty_viewer = true
                    this.attachments.attachmentTab = true
                    this.from = 0
                    this.allowAttachmentItemsLoadMore = false
                    this.getAttachmentsDataByFilter()
                }
                else if(this.tab == 5)
                {
                    this.empty_viewer = true;
                    this.attachments.attachmentTab = true;
                    this.getAllUsersByFilter();
                }
                else if(this.tab == 6)
                {
                    this.empty_viewer = true;
                    this.attachments.attachmentTab = true;
                    this.getAllTemplatesByFilter();
                }
                else if(this.tab == 7)
                {
                    this.empty_viewer = true;
                    this.attachments.attachmentTab = true;
                    this.getAllReportsByFilter();
                }

                this.GetSearchIndexResults()
            },
            getStructures(query) 
            {
                this.structures = [];
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => this.structures = res.data)
                    .catch(err => console.warn(err))
            },
            getAttachmentsDataByFilter(onSearchCompletedHandler)
            {
                this.attachments.attachmentData = [];
                this.attachments.fileExtensions = [];

                this.dateFilters = [
                    { id: "1", text: "Last 30 Days", count: 0 },
                    { id: "2", text: "Last 60 Days", count: 0 },
                    { id: "3", text: "Last 180 Days", count: 0 },
                    { id: "4", text: "Older", count: 0 },
                ]
                var request = {
                    Name: this.searchQuery == null ? "" : this.searchQuery,
                    CreatedDate: (this.attachments.createdDate != null && Object.keys(this.attachments.createdDate).length > 0) ? this.attachments.createdDate : "",
                    Extension: (this.attachments.fileExtension != null && Object.keys(this.attachments.fileExtension).length > 0) ? this.attachments.fileExtension : "",
                    From: 0,
                    PageSize: this.pageSize,
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/SearchAttachments', request, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.attachments.fileExtensions = []

                        if (res != null)
                        {
                            if (res.data.data != '[]')
                                this.attachments.attachmentData = JSON.parse(res.data.data)
                            
	                        this.getAttachmentFilters(res.data, request.CreatedDate, request.Extension);
                        }

                        if (onSearchCompletedHandler != null && onSearchCompletedHandler != undefined)
                            onSearchCompletedHandler()

                        if (res.data.totalRecords == this.attachments.attachmentData.length)
                            this.allowAttachmentItemsLoadMore = false;
                        else
                            this.allowAttachmentItemsLoadMore = true;
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());  
            },
            loadMoreAttachments($state)
            {
                if (this.from != 0 && this.allowAttachmentItemsLoadMore == false)
                {
                    $state.complete();
                    return;
                }

                this.from = this.from + 20;
                var request = {
                    Name: this.searchQuery == null ? "" : this.searchQuery,
                    CreatedDate: (this.attachments.createdDate != null && Object.keys(this.attachments.createdDate).length > 0) ? this.attachments.createdDate : "",
                    Extension: (this.attachments.fileExtension != null && Object.keys(this.attachments.fileExtension).length > 0) ? this.attachments.fileExtension : "",
                    From: this.from,
                    PageSize: this.pageSize,
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/SearchAttachments', request, { headers: constants.headers })
                    .then((res) => 
                    {
                        if (res != null)
                        {
                            if (res.data.data != '[]')
                            {
                                 var newAttachments = JSON.parse(res.data.data)
                                 this.attachments.attachmentData.push(...newAttachments)
                            }
                            
                            if (this.from >= res.data.totalRecords) 
                                $state.complete()
                            
                            if (res.data.totalRecords == this.attachments.attachmentData.length)
                                $state.complete()
                            else
                                $state.loaded()
                        }
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading()); 
            },
            getAllUsersByFilter()
            {
                this.user_items = [];
                axios.get(constants.baseApiUrl + 'Search/GetAllUsersByFilter?query=' + this.searchQuery, null, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.user_items = res.data
                    })
                    .catch((err) => console.warn(err));
            },
            getAllTemplatesByFilter()
            {
                axios.get(constants.baseApiUrl + 'Search/GetAllTemplatesByFilter?query=' + this.searchQuery, null, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.template_items = res.data
                        this.template_items.forEach((item) => {
                            item.category = constants.categories.find(x => x.id == item.categoryId).name
                        });
                    })
                    .catch((err) => console.warn(err));
            },
            getAllReportsByFilter()
            {
                axios.get(constants.baseApiUrl + 'Search/GetAllReportsByFilter?query=' + this.searchQuery, null, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.report_items = res.data
                    })
                    .catch((err) => console.warn(err));
            },
            getCorrespondenceItems(onSearchCompletedHandler)
            {
                this.dateFilters = [
                    { id: "1", text: "Last 30 Days", count: 0 },
                    { id: "2", text: "Last 60 Days", count: 0 },
                    { id: "3", text: "Last 180 Days", count: 0 },
                    { id: "4", text: "Older", count: 0 },
                ]

                var searchData = {
                    Message: this.searchQuery,
                    CategoryId: (this.selectedCategory != null && Object.keys(this.selectedCategory).length > 0) ? this.selectedCategory : "",
                    PriorityId: (this.selectedPriority != null && Object.keys(this.selectedPriority).length > 0) ? this.selectedPriority : "",
                    PrivacyId:  (this.selectedPrivacy != null && Object.keys(this.selectedPrivacy).length > 0) ? this.selectedPrivacy : "",
                    StatusId:   (this.selectedStatus != null && Object.keys(this.selectedStatus).length > 0) ? this.selectedStatus : "",
                    DocumentCreatedDate: (this.selectedDocumentDate != null && Object.keys(this.selectedDocumentDate).length > 0) ? this.selectedDocumentDate : "",
                    TransferToStructure: (this.selectedToStructure != null && Object.keys(this.selectedToStructure).length > 0) ? this.selectedToStructure.id : "",
                    TransferFromStructure: (this.selectedFromStructure != null && Object.keys(this.selectedFromStructure).length > 0) ? this.selectedFromStructure.id : "",
                    AttachmentCreatedDate: "",
                    AttachmentExtension: "",
                    from: 0,
                    PageSize: this.pageSize,
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/SearchTransfers', searchData, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.correspondence_items = []
                        this.getCorrespondenceFilters(res.data, searchData.DocumentCreatedDate)
                        var correspondences = []
                        if (res.data.data != [])
                            correspondences = JSON.parse(res.data.data)

                        correspondences.forEach((element) => {
                            element.status = this.statuses.find(x => x.id == element.statusId).name
                            element.transferCreatedDate = new Date(element.transferCreatedDate).toLocaleDateString('fr-CA', this.options)
                            element.transferDueDate = element.transferDueDate != null ? new Date(element.transferDueDate).toLocaleDateString('fr-CA', this.options) : ""
                            
                            this.correspondence_items.push(element);
                        });

                        if (onSearchCompletedHandler != null && onSearchCompletedHandler != undefined)
                            onSearchCompletedHandler()

                        if (res.data.totalRecords == this.correspondence_items.length)
                            this.allowCorrespondenceItemsLoadMore = false;
                        else
                            this.allowCorrespondenceItemsLoadMore = true;
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            loadMoreCorrespondences($state)
            {
                if (this.from != 0 && this.allowCorrespondenceItemsLoadMore == false)
                {
                    $state.complete();
                    return;
                }

                this.from = this.from + 20;
                var searchData = {
                    Message: this.searchQuery,
                    CategoryId: (this.selectedCategory != null && Object.keys(this.selectedCategory).length > 0) ? this.selectedCategory : "",
                    PriorityId: (this.selectedPriority != null && Object.keys(this.selectedPriority).length > 0) ? this.selectedPriority : "",
                    PrivacyId:  (this.selectedPrivacy != null && Object.keys(this.selectedPrivacy).length > 0) ? this.selectedPrivacy : "",
                    StatusId:   (this.selectedStatus != null && Object.keys(this.selectedStatus).length > 0) ? this.selectedStatus : "",
                    DocumentCreatedDate: (this.selectedDocumentDate != null && Object.keys(this.selectedDocumentDate).length > 0) ? this.selectedDocumentDate : "",
                    TransferToStructure: (this.selectedToStructure != null && Object.keys(this.selectedToStructure).length > 0) ? this.selectedToStructure.id : "",
                    TransferFromStructure: (this.selectedFromStructure != null && Object.keys(this.selectedFromStructure).length > 0) ? this.selectedFromStructure.id : "",
                    AttachmentCreatedDate: "",
                    AttachmentExtension: "",
                    from: this.from,
                    PageSize: this.pageSize,
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/SearchTransfers', searchData, { headers: constants.headers })
                    .then((res) => 
                    {
                        var correspondences = []
                        if (res.data.data != [])
                            correspondences = JSON.parse(res.data.data)

                        correspondences.forEach((element) => {
                            element.status = this.statuses.find(x => x.id == element.statusId).name
                            element.transferCreatedDate = new Date(element.transferCreatedDate).toLocaleDateString('fr-CA', this.options)
                            element.transferDueDate = element.transferDueDate != null ? new Date(element.transferDueDate).toLocaleDateString('fr-CA', this.options) : ""
                            
                            this.correspondence_items.push(element);
                        });
                        
                        if (this.from >= res.data.totalRecords) 
                            $state.complete()
                        
                        if (res.data.totalRecords == this.correspondence_items.length)
                            $state.complete()
                        else
                            $state.loaded()

                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            getNotesDataByFilter(onSearchCompletedHandler)
            {
                var searchData = {
                    NoteText:  this.searchQuery,
                    CreatedDate: (this.note_createDateFilterValue != '' ? this.note_createDateFilterValue : ''),
                    CreatedByUser: (this.note_createdByUserFilterValue.id != undefined ? this.note_createdByUserFilterValue.id.split('-')[0] : ''),
                    from: 0,
                    PageSize: this.pageSize,
                }

                axios.post(constants.baseApiUrl + 'Search/SearchNotes', searchData)
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            this.note_items = []
                            if (res.data.data != '[]')
                                this.note_items = JSON.parse(res.data.data);
                            
                            var noteDateKeys = Object.keys(res.data.createdDateAggregation)
                            var noteDateValues = Object.values(res.data.createdDateAggregation)
                            var count = 0

                            noteDateKeys.forEach((key) => 
                            {
                                this.notesDateFilters.find(x => x.text == key).count = 
                                    (noteDateValues[count] == null || noteDateValues[count] == undefined ) ? 0 : noteDateValues[count];
                                count++;
                            });

                            if (onSearchCompletedHandler != null && onSearchCompletedHandler != undefined)
                                onSearchCompletedHandler()
                            
                            if (res.data.totalRecords == this.note_items.length)
                                this.allowNoteItemsLoadMore = false;
                            else
                                this.allowNoteItemsLoadMore = true;
                        }
                    });
            },
            loadMoreNotes($state)
            {
                if (this.from != 0 && this.allowNoteItemsLoadMore == false)
                {
                    $state.complete();
                    return;
                }

                this.from = this.from + 20
                var searchData = {
                    NoteText:  this.searchQuery,
                    CreatedDate: (this.note_createDateFilterValue != '' ? this.note_createDateFilterValue : ''),
                    CreatedByUser: (this.note_createdByUserFilterValue.id != undefined ? this.note_createdByUserFilterValue.id.split('-')[0] : ''),
                    from: this.from,
                    PageSize: this.pageSize,
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Search/SearchNotes', searchData)
                    .then((res) => 
                    {
                        if (res != null && res.data != null)
                        {
                            if (res.data.totalRecords == this.note_items.length)
                                this.allowNoteItemsLoadMore = false
                            else
                                this.allowNoteItemsLoadMore = true

                            if (res.data.data != '[]')
                            {
                                 var newNotes = JSON.parse(res.data.data)
                                 this.note_items.push(...newNotes)
                            }
                            
                            if (this.from >= res.data.totalRecords) 
                                $state.complete()
                            
                            if (res.data.totalRecords == this.note_items.length)
                                $state.complete()
                            else
                                $state.loaded()
                        }
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            getAttachmentFilters(aggregations, createdDate, fileExtension)
            {
                var attachmentDateKeys = Object.keys(aggregations.createdDateAggregation)
                var attachmentDateValues = Object.values(aggregations.createdDateAggregation)
                var count = 0

                attachmentDateKeys.forEach((key) => 
                {
                    this.dateFilters.find(x => x.text == key).count = 
                        (attachmentDateValues[count] == null || attachmentDateValues[count] == undefined ) ? 0 : attachmentDateValues[count];
                    count++;
                });
                
                this.dateFilters = this.dateFilters.filter(date => {
                    if (createdDate == '' || date.text == createdDate)
                        return true
                    else
                        return false
                })

                var fileExtensionKeys = Object.keys(aggregations.fileExtensionAggregation)
                var fileExtensionValues = Object.values(aggregations.fileExtensionAggregation)
                var count = 0
                this.fileExtensionsFilter = []

                fileExtensionKeys.forEach((key) => 
                {
                    var item = { id: key, text: this.fileExtensions.find(x => x.id == key).name, count: fileExtensionValues[count]}
                    this.fileExtensionsFilter.push(item);
                    count++;
                });

                this.fileExtensionsFilter = this.fileExtensionsFilter.filter(file => 
                {
                    if (fileExtension == '' || file.text == fileExtension)
                        return true
                    else
                        return false
                })
            },
            getCorrespondenceFilters(aggregations, documentCreatedDate)
            {
                var categoryKeys = Object.keys(aggregations.categoryAggregation)
                var categoryValues = Object.values(aggregations.categoryAggregation)
                var count = 0
                this.categoryFilters = []

                categoryKeys.forEach((key) => 
                {
                    var item = { id: key, text: this.categories.find(x => x.id == key).name, count: categoryValues[count]}
                    this.categoryFilters.push(item);
                    count++;
                });

                var privacyKeys = Object.keys(aggregations.privacyAggregation)
                var privacyValues = Object.values(aggregations.privacyAggregation)
                var count = 0
                this.privacyFilters = []

                privacyKeys.forEach((key) => 
                {
                    this.privacyFilters.push({ 
                        id: key, 
                        text: this.privacies.find(x => x.id == key).name, 
                        count: privacyValues[count]
                    });
                    count++;
                });

                var statusKeys = Object.keys(aggregations.documentStatusAggregation)
                var statusValues = Object.values(aggregations.documentStatusAggregation)
                var count = 0
                this.statueFilters = []

                statusKeys.forEach((key) => 
                {
                    this.statueFilters.push({ 
                        id: key, 
                        text: this.statuses.find(x => x.id == key).name, 
                        count: statusValues[count]
                    });
                    count++;
                });

                var priorityKeys = Object.keys(aggregations.priorityAggregation)
                var priorityValues = Object.values(aggregations.priorityAggregation)
                var count = 0
                this.priorityFilters = []

                priorityKeys.forEach((key) => {
                    var item = { id: key, text: this.priorities.find(x => x.id == key).name, count: priorityValues[count]}
                    this.priorityFilters.push(item);
                    count++;
                });

                var documentDateKeys = Object.keys(aggregations.documentDateAggregation)
                var documentDateValues = Object.values(aggregations.documentDateAggregation)
                var count = 0

                documentDateKeys.forEach((key) => {
                    this.dateFilters.find(x => x.text == key).count = (documentDateValues[count] == null 
                    || documentDateValues[count] == undefined ) ? 0 : documentDateValues[count];
                    count++;
                });

                if(documentCreatedDate != "")
                {
                    this.dateFilters = this.dateFilters.filter( date => {
                        if(date.text == documentCreatedDate)
                        {
                            return true;
                        }
                        else
                        {
                            return false;
                        }
                    })
                }
            },
            asyncFindUser(query)
            {
                if (query == '') return

                utils.defaultGet(
                    'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=' + query, 
                    (res) => { this.notes_usersList = res.data; this.loading = false; }, this.handleError, true);
            },
            handleResultClicked(item)
            {
                this.selected_item = item
                
                var documentId = 0
                var transferId = 0
                var instruction = ''
                var transferFromUserId = 0
                
                if (this.tab == 2)
                {
                    transferId = item.id
                    documentId = item.documentId
                    instruction = item.instruction
                    transferFromUserId = item.transferFromUserId
                }
                if (this.tab == 3)
                {
                    documentId = item.documentId
                    transferId = item.transferId
                    instruction = item.transferInstruction
                    transferFromUserId = item.transferFromUserId
                }   
                if (this.tab == 4)
                {
                    documentId = item.DocumentId
                    transferId = item.TransferId
                    item.attachmentId = item.AttachmentId
                    instruction = item.TransferInstruction
                    transferFromUserId = item.TransferFromUserId
                }   
                
                if (item.attachmentId != null && item.attachmentId != undefined)
                {
                    this.no_item_selected = false
                    this.empty_viewer = false 

                    // this.viewerFrame = constants.viewerUrl + '?id=' + item.attachmentId + '&documentId=' + documentId + 
                    //         '&token=' + sessionStorage.getItem('jwt_token') +'&lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view&r=' + new Date().getTime()
                  
                    window.setViewerData(item.attachmentId , documentId);
                    this.viewerFrame = '/resources/viewer/viewer.html?lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view&r=' + new Date().getTime()
                }
                else
                {
                    this.no_item_selected = false
                    this.empty_viewer = true
                }

                var context= this;
                setTimeout(() => 
                {
                    if(context.$refs.transferNotesIcon)
                    {
                        context.$refs.transferNotesIcon.showTransferNotes(transferFromUserId, instruction);
                    }
                }, 50);
            },
            CapitalizeFirstLetter(str)
            {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
			goToTabPage(tabPageNumber) 
			{
                this.showTab(tabPageNumber)
			},
            openFullView()
            {
                var user = JSON.parse(sessionStorage.getItem("user"))
                var documentId = 0, transferId = 0, transferStatusId = 0, transferFromUserId = 0, transferToUserId = 0
                if (this.tab == 2)
                {
                    transferId = this.selected_item.id
                    documentId = this.selected_item.documentId
                    transferStatusId = this.selected_item.transferStatusId
                    transferFromUserId = this.selected_item.transferFromUserId
                    transferToUserId = this.selected_item.transferToUserId
                }
                else if (this.tab == 3)
                {
                    documentId = this.selected_item.documentId
                    transferId = this.selected_item.transferId
                    transferStatusId = this.selected_item.transferStatusId
                    transferFromUserId = this.selected_item.transferFromUserId
                    transferToUserId = this.selected_item.transferToUserId
                }
                else if (this.tab == 4)
                {
                    documentId = this.selected_item.DocumentId
                    transferId = this.selected_item.TransferId
                    transferStatusId = this.selected_item.TransferStatusId
                    transferFromUserId = this.selected_item.TransferFromUserId
                    transferToUserId = this.selected_item.TransferToUserId
                }   

                this.viewMode = 'readonly'
                
                if (this.selected_item.statusId == 2 && transferStatusId == 1)
                {
                    if (transferFromUserId == user.profile.Id)
                        this.viewMode = 'readonly'
                    else if (transferToUserId == user.profile.Id)
                        this.viewMode = 'edit_new'
                }
                
                this.transferId = transferId
                this.documentId = documentId
                this.correspondenceDialog = true
            },
            closeCorrespondenceDialog() 
            {
                this.delegationId = 0
                this.documentId = 0
                this.transferId = 0
                this.correspondenceDialog = false
            },
            handleError(error)
            {
                console.log(error)
                window.showAlert('An error has occured', 'error')
            },
            closePreview() 
            {
                this.openPreviewPane = false
            },
            getLookups()
            {
                this.purposes = constants.purposes
                this.statuses = constants.statuses
                this.priorities = constants.priorities
                this.privacies = constants.privacies
                this.categories = constants.categories
                this.fileExtensions = constants.fileExtensions
            },
            getBackgroundColor (status) 
            {
                if (status == 'Completed') return '#F0F7E7;'
                else if (status == 'Canceled') return '#FFF1F1;'
                else if (status == 'In progress') return '#FFF5ED'
                else if (status == 'Draft') return 'white'
                else return 'white'
            },
            getTextColor (status) 
            {
                if (status == 'Completed') return '#009639;'
                else if (status == 'Canceled') return '#EA0000'
                else if (status == 'In progress') return '#F77600'
                else if (status == 'Draft') return 'black'
                else return 'white'
            },
            getColor(status)
            {
                if (status == 'Completed') return 'success'
                else if (status == 'Canceled') return 'danger'
                else if (status == 'In progress') return 'info'
                else if (status == 'Draft') return ''
                else return ''
            },
            getStatusColor(statusId)
            {
                return constants.statusesEnum.getById(statusId).data().classColor;
            },
            getStatusName(statusId)
            {
               return constants.statusesEnum.getById(statusId).data().name;
            },
            getPurposeName(purposeId)
            {
                var item = constants.purposes.find(x => x.id == purposeId)
                if (item != undefined && item != null) 
                    return item.name
            },
            getCategoryName(categoryId)
            {
                var item = constants.categories.find(x => x.id == categoryId)
                if (item != undefined && item != null) 
                    return item.name
            },
            // getOverdue(dueDateString)
            // {
            //     var dueDate = new Date(dueDateString)
            //     var nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
                
            //     let nearDate = new Date(); // Get current date
            //     nearDate.setDate(nearDate.getDate() + 3); // Add 3 days to current date

            //     if (nowDate >= dueDate) 
            //         return 'mdi-overdue'
            //     else if (nowDate.getDate() == dueDate.getDate() && nowDate.getMonth() == dueDate.getMonth() && nowDate.getFullYear() == dueDate.getFullYear())
            //         return 'mdi-overdue'
            //     else if (nearDate >= dueDate)
            //         return 'mdi-clock'
            //     else if (nearDate.getDate() == dueDate.getDate() && nearDate.getMonth() == dueDate.getMonth() && nearDate.getFullYear() == dueDate.getFullYear())
            //         return 'mdi-clock'
            //     else
            //         return ''
            // },
            getOverdueDays(dueDateString)
            {
                var dueDate = new Date(dueDateString)
                var nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
                var overdue = this.getOverdue(dueDateString)

                if (overdue == '') 
                    return ''
                else if (overdue == "mdi-overdue") 
                    return 'overdue'
                else if (overdue == "mdi-clock")
                {
                    const timeDiff = Math.abs(dueDate.getTime() - nowDate.getTime());
                    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                    return diffDays + ' days'
                }  

                return ''
            },
            dateFormat: function (inputDate, format) {
                const date = new Date(inputDate);

                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();

                format = format.replace("MM", month.toString().padStart(2, "0"));

                if (format.indexOf("yyyy") > -1) {
                    format = format.replace("yyyy", year.toString());
                } else if (format.indexOf("yy") > -1) {
                    format = format.replace("yy", year.toString().substr(2, 2));
                }

                format = format.replace("dd", day.toString().padStart(2, "0"));
                return format;
            },
            formatDate(date)
            {
                try 
                {
                    var date = new Date(date)
                    var day = date.getDate();
                    if (day < 10)
                        day = '0' + day
                    var month = date.getMonth() + 1;
                    if (month < 10)
                        month = '0' + month
                    var year = date.getFullYear().toString().substring(2, 4)

                    return `${day}/${month}/${year}`;
                }
                catch (err) 
                {
                    console.log(err); 
                    return ''; 
                }
            },
            highlightText(text)
            {
                try
                {
                    var retVal = text
                    var keyword = utils.getParameterByName('q')
                    if (retVal.length > 150)
                    {
                        retVal = this.trimTextWithKeyword(retVal, keyword, 150)
                    }
                    retVal = retVal.replace(new RegExp(keyword, 'gi'), '<span style="font-weight:700; text-decoration:underline;">$&</span>');
                    return retVal;
                }
                catch(err)
                {
                    console.log(err)
                    return text
                }
            },
            trimTextWithKeyword(text, keyword, maxLength) 
			{
				const keywordIndex = text.toLowerCase().indexOf(keyword.toLowerCase());

				if (keywordIndex === -1) 
				{
					// If the keyword is not found, return the trimmed text without the keyword
					return text.substring(0, maxLength).trim();
				}

				const startIndex = Math.max(0, keywordIndex - Math.floor((maxLength - keyword.length) / 2));
				let trimmedText = text.substring(startIndex, startIndex + maxLength).trim();

				if (startIndex > 0) 
				{
					// Prepend "..." if the trimmed text does not start from the beginning of the original text
					trimmedText = `...${trimmedText}`;
				}

				if (startIndex + maxLength < text.length) 
				{
					// Append "..." if the trimmed text does not reach the end of the original text
					trimmedText = `${trimmedText}...`;
				}

				return trimmedText;
			},
            displayOverdueForCorrespondence(item)
            {
                try 
                {
                    if (item.transfers[0].dueDate < new Date().toISOString().split('T')[0])
                        return 'mdi-overdue'
                    else
                        return ''

                    return new Date(item.createdDate).toLocaleString().replace(',', '')
                }
                catch (err) { console.log(err); return ''; }
            },
            templateClicked(item)
            {
                this.template_click = 0

                var signatoryList = ''

                var defaultFormData = '{"senderDesignatedPerson": "", "recipientDesignatedPerson": "", "translatedSubject": "", "keywords": "", "otherAttachments": "", '
                defaultFormData = defaultFormData + '"signers": "[' + signatoryList + ']", "templateId": ' + item.id + '}'

                var user = JSON.parse(sessionStorage.getItem("user"));
                
                var saveParams = {
                    'CategoryId': item.categoryId,
                    "TemplateId": item.id,
                    'CreatedByStructureId': user.profile.StructureId,
                    'formData': defaultFormData                 
                };

                const headers = { 
                    'Content-Type': 'application/x-www-form-urlencoded', 
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') 
                };

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/Save', saveParams, { headers: headers })
                    .then((response) =>
                    {
                        if (response.status == 200)
                        {
                            var documentId = response.data
                            window.openNewCorrespondenceDialog(documentId)
                        }
                        else
                        {
                            alert(response.data.message);
                        }
                    })
                    .catch((err) => console.log(err))
                    .finally(() => window.hideLoading())
            },
            openReport(reportId)
            {
                this.$router.push({ name: 'report', query: { id: reportId } })
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .v-sheet.v-card:not(.v-sheet--outlined) {
        border-radius: 12px;
    }
    .multiselect__select { display: none !important; }

    .v-popper--theme-tooltip { max-width: 400px !important;}
    .combined-paragraph {
        display: flex;
        flex-wrap: wrap;
    }

    .combined-paragraph > span 
    {
        order: 1;
        margin-left: auto;
        background-color: yellow;
    }

    .search {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: auto;
    }

    .search h2.dark-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        /* identical to box height, or 114% */
        letter-spacing: 0.01em;
    }
    
    .grid-4-items .dark-title.size-16[data-v-0a4933a7] {
        white-space: normal;
        word-break: break-word;
    }

    .search .px-1rem {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }

    .search h4 {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #455664;
        word-break: break-word;
        margin-bottom: 0.75rem;
    }

    .search p {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #455664;
    }

    .search .theme--dark.v-chip.purple {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
    }

    .btn-text.text-primary {
        line-height: 16px;
    }
</style>